// Publisher-scoped route origins. Triple '-' keeps these disjoint from the existing
// <site-rkey>--<did-suffix> namespace. Never reinterpret an existing site's origin.
const NAME = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
const PLC = /^[a-z2-7]{24}$/;

/** DNS-compatible subset of ATW short names; case-sensitive names are never folded. */
export function nameOriginLabel(did: string, name: string): string | null {
  if (!did.startsWith("did:plc:")) return null;
  const suffix = did.slice(8);
  if (!PLC.test(suffix) || !NAME.test(name)) return null;
  const label = `${name}---${suffix}`;
  return label.length <= 63 ? label : null;
}

export function parseNameOriginLabel(label: string): { did: string; name: string } | null {
  const split = label.indexOf("---");
  if (split < 0) return null;
  const name = label.slice(0, split);
  const did = `did:plc:${label.slice(split + 3)}`;
  return nameOriginLabel(did, name) === label ? { did, name } : null;
}
